import React, { Component } from 'react';
import {Card, CardBody} from "reactstrap";
import ReactTable from 'react-table'
import { Link } from 'react-router';
import { ReactTableDefaults } from 'react-table'
class DataTable extends Component {

    constructor(props,context) {
      super(props,context);

      this.columns = this.props.columns;

      if(this.props.additionalColumns && this.columns)
      {
        this.columns = [...this.columns, ...this.props.additionalColumns]
      }

      this.searchScope = localStorage.getItem('searchScope');

      this.tableScope = this.searchScope + '_table';

     this.pageSize = localStorage.getItem(this.tableScope);

    }

    _savePageSize(pageSize, page) {
      
      
      localStorage.setItem(this.tableScope, pageSize);

      this.setState({ pageSize: pageSize, page: page });
    }

  	render() {

  		return (
  			<div>
    				<ReactTable
              data={this.props.data}
              columns={this.columns}
              defaultSorted={this.props.defaultSorted ? this.props.defaultSorted : []}
              defaultPageSize={this.pageSize ? this.pageSize : 10}
              onPageSizeChange={(pageSize, page) => {                
                this._savePageSize(pageSize,page );
              }}
              previousText="Vorige"
              nextText='Volgende'
              loadingText='Laden...'
              noDataText='Geen data gevonden'
              pageText='Pagina'
              ofText='van'
              rowsText='rijen'
            />
		    </div>
  		)
  	}
}

export default DataTable



// WEBPACK FOOTER //
// ./src/components/DataTable/index.js